import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../../core';
import { ClienteCentralCompra } from '../cliente-central-compra';
import { ClienteCentralCompraParticipante } from '../participante';
import { ClienteCentralCompraHttpService } from '../services';

@Component({
    selector: 'sgt-cliente-central-compra-select-participante-modal',
    templateUrl: './cliente-central-compra-select-participante-modal.component.html',
    styleUrls: ['./cliente-central-compra-select-participante-modal.component.less']
})
export class ClienteCentralCompraSelectParticipanteModalComponent implements OnInit {
    elModal: any;
    @ViewChild('modal', {static: true}) modal: ElementRef;

    /** Subtitle do modal */
    @Input() subtitle: string = null;

    /** Evento emitido ao selecionar o participante da central de compras */
    @Output() onSelectParticipante = new EventEmitter<ClienteCentralCompraParticipante>();
    /** Ao cancelar a seleção de um participante da central de compras */
    @Output() onCancelSelectParticipante = new EventEmitter<void>();

    /** ID da central de compras */
    idClienteCentralCompras: number;
    /** Central de compras */
    centralCompras: ClienteCentralCompra;
    isLoadingCentralCompra: boolean;
    isLoadedCentralCompra: boolean;

    constructor(private messageService: MessageService,
                private clienteCentralCompraHttpService: ClienteCentralCompraHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.modal?.nativeElement) as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.load();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    /** Abre o modal para selecionar um participante da central de compras informada */
    open(idClienteCentralCompras: number) {
        this.idClienteCentralCompras = idClienteCentralCompras;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Fecha o modal */
    private close() {
        this.elModal.modal('hide');
    }

    /** Carrega a central de compras e seus participantes */
    private load() {
        if (!this.idClienteCentralCompras) {
            return;
        }

        this.isLoadingCentralCompra = true;
        this.isLoadedCentralCompra = false;
        this.centralCompras = null;
        this.clienteCentralCompraHttpService.load(this.idClienteCentralCompras)
            .pipe(
                take(1)
            )
            .subscribe(
                centralCompras => {
                    this.centralCompras = centralCompras;
                    this.isLoadingCentralCompra = false;
                    this.isLoadedCentralCompra = true;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a central de compras', error);
                    this.isLoadingCentralCompra = false;
                    this.isLoadedCentralCompra = false;
                }
            );
    }

    /** Ao selecionar um participante da central de compras */
    selectParticipante(participante: ClienteCentralCompraParticipante) {
        this.onSelectParticipante.emit(participante);
        this.close();
    }

    /** Limpa as variáveis do modal */
    private clear() {
        this.idClienteCentralCompras = null;
        this.centralCompras = null;
        this.isLoadingCentralCompra = false;
        this.isLoadedCentralCompra = false;
    }

    /** Cancela e fecha o modal */
    cancel() {
        this.onCancelSelectParticipante.emit();
        this.close();
    }
}
